import { Vue } from 'vue-property-decorator';
import tableMixin from '../../../Mixins/table';
import moment from 'moment';

export default Vue.extend({
  mixins: [tableMixin],
  props: {
    transactions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      associatedIdTooltip: false,
      // Controls whether the help dialog for this page is open
      helpOpen: false,
      transactionHeaders: [
        { text: 'ID', align: 'center', value: 'id', sortable: true },
        { text: 'Created', align: 'center', value: 'created_at', sortable: true },
        { text: 'Amount (minutes)', align: 'center', value: 'amount', sortable: true },
        { text: 'Type', align: 'center', value: 'type', sortable: true },
        { text: 'Description', align: 'center', value: 'description', sortable: false },
        { text: 'Associated Type', align: 'center', value: 'associated_type', sortable: true },
        { text: 'Appointment ID / Admin ID', align: 'center', value: 'associated_id', sortable: true },
        { text: 'Appointment Status', align: 'center', value: 'appointment_status', sortable: true },
      ],
    };
  },
  methods: {
    formatDateTime(value) {
      if (!value) return '-';
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
    packageTypeLabel(value) {
      const map = {
        time: 'Bundle',
        free: 'PPU',
        donation: 'WoS',
      };
      return map[value] || value || '-';
    },
  },
});
